import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useAccount } from "wagmi";

export default function ReferralShare() {
  const { address } = useAccount();
  const [referrallink, setReferrallink] = useState(
    "Please connect your wallet"
  );
  const [refcopy, setRefcopy] = useState(false);
  let base_url = `${window.location.origin}/swap?ref=`;

  useEffect(() => {
    if (address) {
      setReferrallink(`${base_url}${address}`);
    } else {
      setReferrallink("Please connect your wallet");
    }
  }, [address, base_url]);

  return (
    <div className="row mt-4 mb-5 d-flex justify-content-center">
      <div className="col-md-8 col-lg-6">
        <div className="card">
          <div class="ref-main text-center text-white">
            <article class="presentation">
              <h2 class="page-title text-website">Refer Friends.Earn Reward</h2>
              <p class="description">Earn up to 3% commission on every swap.</p>
            </article>
            <div class="input-group mx-3 my-3 d-flex justify-content-center">
              <input
                type="text"
                className="ref-input"
                value={referrallink}
                readOnly={true}
              />
              <span class="input-group-text" id="basic-addon2">
                <CopyToClipboard
                  text={`${base_url}${address}`}
                  onCopy={() => {
                    setRefcopy(true);
                    setTimeout(() => {
                      setRefcopy(false);
                    }, 2000);
                  }}
                >
                  {refcopy ? (
                    <ContentPasteIcon sx={{ color: "#fff" }} fontSize="small" />
                  ) : (
                    <ContentCopyIcon sx={{ color: "#fff" }} fontSize="small" />
                  )}
                </CopyToClipboard>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
